import { PortfolioProjectCardAttachment } from '../../components';
import { AttachmentsBadgeProps } from '../../components/PortfolioProjectBadge/AttachmentsBadge';
import { isAudio, isImage, isVideo } from '../getAttachmentType';

const EMPTY_ATTACHMENTS = { videos: undefined, images: undefined, audios: undefined };

export const getAttachmentsCount = (attachments?: PortfolioProjectCardAttachment[]): AttachmentsBadgeProps => {
    if (!attachments?.length) {
        return EMPTY_ATTACHMENTS;
    }

    return attachments.reduce(
        (acc, attachment) => {
            if (attachment?.type && isImage(attachment.type)) {
                acc.images++;
            }

            if (attachment?.type && isVideo(attachment.type)) {
                acc.videos++;
            }

            if (attachment?.type && isAudio(attachment.type)) {
                acc.audios++;
            }

            return acc;
        },
        { images: 0, videos: 0, audios: 0 }
    );
};
export const getAttachmentType = (attachments?: PortfolioProjectCardAttachment[]) => attachments?.[0]?.type;
